import React from 'react';
import { useTranslation } from 'react-i18next';

import { OmaLummeApp } from '../../../../omaLummeContext';
import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsRadio from '../ManageContractsRadioCheckbox';

// Utils.
import { generateAddress } from '../../../../utils/address';
import ManageContractsAddressFields from '../ManageContractsAddressFields';

export const MoveNoNewContract: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { users } = OmaLummeApp.useState();
  const { changePrimaryAddress, endDate, primaryAddress } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepNewAddressMoveNoNewContract">
      <h3>{t('manageContracts:manageContracts.NewAddressMoveNoNewContractTitle')}*</h3>

      <div className="form-items">
        <ManageContractsRadio
          radioID="manageContractsChangePrimaryAddressYes"
          radioName="manageContractsChangePrimaryAddress"
          onChangeFunc={(): void => {
            dispatch(['primaryAddressChange', true]);
            dispatch(['newAddressDate', endDate]);
          }}
          checkedComparison={changePrimaryAddress === true}
          label={t('manageContracts:manageContracts.NewAddressMoveNoNewContractNew')}
        />
        {changePrimaryAddress && (
          <ManageContractsAddressFields
            address={primaryAddress}
            action="newPrimaryAddress"
            showNameFields={false}
            showSSN={false}
            showMobilePhoneNumber={false}
          />
        )}

        <ManageContractsRadio
          radioID="manageContractsChangePrimaryAddressNo"
          radioName="manageContractsChangePrimaryAddress"
          onChangeFunc={(): void => dispatch(['primaryAddressChange', false])}
          checkedComparison={changePrimaryAddress === false}
          label={`${t('manageContracts:manageContracts.NewAddressMoveNoNewContractCurrent')} <strong>${generateAddress(
            users.activeUser.userAddress[0],
            false,
          )}</strong>`}
        />
      </div>
    </section>
  );
};

export default MoveNoNewContract;
